import * as angular from 'angular';

import { RegentsPlanningStepperModule } from './regents-planning-stepper/regents-planning-stepper.module';
import { RegentsPlanningTableModule } from './regents-planning-table/regents-planning-table.module';
import { RegentsPlanningWizardComponent } from './regents-planning-wizard.component';

export const RegentsPlanningWizardModule = angular
  .module('regentsPlanningWizardModule', [RegentsPlanningStepperModule, RegentsPlanningTableModule])
  .component('regentsPlanningWizard', RegentsPlanningWizardComponent).name;
